export const defaultInputContainerTextFieldStyles = {
  // height: 42,
  fontSize: '14px !important',
  borderColor: 'transparent !important',
  borderWidth: '0px !important',
}
export const defaultLabelTextFieldStyles = {
  variant: 'caption' as const,
  component: 'label' as const,
  paddingBottom: '4px',
}
